import { Injectable } from '@angular/core';
import { MapState } from './map-state';
import { MAX_PAST_ORDERS } from '../setup/form/constants';
import { getAccountPlatform } from '../../integrate/platform_type';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MapStateCreator {

  constructor(private translateService: TranslateService) {}

  create(allData: any): MapState {
    const isNewEditorEnabled = allData.feature.Postman.hasFeature && allData.flags.ugcPostman;
    const isNewDeliveryEnabled = allData.feature.Postman.hasFeature && allData.flags.ugcPostmanDelivery;

    return {
      enabled: allData.reminder.enabled,
      pastOrdersEnabled: true,
      storeName: allData.account.storeName,
      subject: allData.reminder.subject,
      message: this.getMessage(isNewEditorEnabled, allData.reminder.message),
      signatureChanged: false,
      subjectChanged: false,
      bodyChanged: false,
      id: allData.reminder.id,
      pastOrders: this.getPastOrderDays(allData.feature.Map.minimumContentNomineeCreationDate),
      missingProduct: false,
      totalOrders: allData.account.totalOrders,
      hasOrderLimitFeature: allData.feature.OrderLimit.hasFeature,
      hasPostmanEditorFeature: isNewEditorEnabled,
      hasPostmanDeliveryFeature: isNewDeliveryEnabled,
      doneInstallation: false,
      platform: getAccountPlatform(allData.account.platform)
    };
  }

  private getMessage(isNewEditorEnabled: boolean, currentMessage: string) {
    if (isNewEditorEnabled && currentMessage === this.translateService.instant('MAP.DEFAULT_MESSAGE')) {
      return this.translateService.instant('MAP.DEFAULT_POSTMAN_EDITOR_MESSAGE');
    }

    return currentMessage;
  }

  private getPastOrderDays(minContentNomineeCreationDate: string): number {
    if (minContentNomineeCreationDate === undefined || minContentNomineeCreationDate === null || Object.keys(minContentNomineeCreationDate).length === 0) {
      return MAX_PAST_ORDERS;
    }

    let currentTime = new Date();
    let minContentNomineeCreationTime = new Date(minContentNomineeCreationDate);
    let diffInMs = Math.abs(currentTime.valueOf() - minContentNomineeCreationTime.valueOf());
    let daysToPull = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    return Math.min(MAX_PAST_ORDERS, daysToPull);
  }

}

